module.exports = __webpack_public_path__ + "static/media/426.904c934f.svg";